const ACCOUNT_TYPE_SESSION_KEY = 'accountType';
const DISPLAY_NAME_SESSION_KEY = 'displayName';
const USER_AGE_SESSION_KEY = 'age';
const IS_PARENT_SESSION_KEY = 'isParent';
const PARENT_EMAIL_SESSION_KEY = 'parentEmail';
const PARENT_EMAIL_OPT_IN_SESSION_KEY = 'parentEmailOptIn';
const USER_STATE_SESSION_KEY = 'state';
const USER_GENDER_SESSION_KEY = 'gender';
const EMAIL_OPT_IN_SESSION_KEY = 'emailOptIn';
const SCHOOL_ID_SESSION_KEY = 'schoolId';
const SCHOOL_ZIP_SESSION_KEY = 'schoolZip';
const SCHOOL_NAME_SESSION_KEY = 'schoolName';

export {
  ACCOUNT_TYPE_SESSION_KEY,
  DISPLAY_NAME_SESSION_KEY,
  USER_AGE_SESSION_KEY,
  IS_PARENT_SESSION_KEY,
  PARENT_EMAIL_SESSION_KEY,
  PARENT_EMAIL_OPT_IN_SESSION_KEY,
  USER_STATE_SESSION_KEY,
  USER_GENDER_SESSION_KEY,
  EMAIL_OPT_IN_SESSION_KEY,
  SCHOOL_ID_SESSION_KEY,
  SCHOOL_ZIP_SESSION_KEY,
  SCHOOL_NAME_SESSION_KEY,
};
